import { EMPTY_ADDRESS_VALUE } from "pages/HardshipApplication/PersonalDetails/AddressField/constants";
import { HardshipState } from "./types";

const initialFrequency = { amount: "", frequency: "monthly" } as const;

export const initialState: HardshipState = {
  isStarted: false,
  acknowledged: false,
  personalDetails: {
    applicantDetails: {
      address: {
        mode: "auto",
        auto: EMPTY_ADDRESS_VALUE,
        streetAddress: "",
        suburb: "",
        city: "",
        postCode: "",
        state: "",
      },
      firstName: "",
      lastName: "",
      dateOfBirth: {
        day: "",
        month: "",
        year: "",
      },
      email: "",
      contactNumber: "",
      employmentStatus: "",
    },
  },
  yourAccounts: {
    accounts: [
      {
        accountType: "",
        accountNumber: "",
        monthlyRepayments: "",
      },
    ],
  },
  liabilities: {
    hadOtherMortgages: "",
    liabilities: [],
  },
  expenses: {
    residential: {
      foodGroceriesHousehold: initialFrequency,
      councilRates: initialFrequency,
      electricity: initialFrequency,
      gas: initialFrequency,
      water: initialFrequency,
      landlineInternetCableTV: initialFrequency,
    },
    other: {
      mobilePhone: initialFrequency,
      medicalPharmaceutical: initialFrequency,
      clothesShoes: initialFrequency,
      petrol: initialFrequency,
      carRegistrationMaintenance: initialFrequency,
      publicTransport: initialFrequency,
      childCare: initialFrequency,
      childMaintenance: initialFrequency,
      educationExpenses: initialFrequency,
      otherHobbies: initialFrequency,
      homeContentsInsurance: initialFrequency,
      carInsurance: initialFrequency,
      healthInsurance: initialFrequency,
      lifeInsurance: initialFrequency,
      otherInsurance: initialFrequency,
      donations: initialFrequency,
    },
  },
  yourIncome: {
    salary: initialFrequency,
    wages: initialFrequency,
    centrelink: initialFrequency,
    businessIncome: initialFrequency,
    other: initialFrequency,
    winzBenefit: initialFrequency,
    irdFamilyTaxCredit: initialFrequency,
    irdChildSupport: initialFrequency,
    rentBoard: initialFrequency,
    investment: initialFrequency,
  },
};
